import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const featuresModule = {
  state,
  mutations,
  actions,
  getters,
};

export default featuresModule;
